import Page from "../framework/Page";
import View from "../framework/View";
import { PageIds } from "../PageIds";

export default class VersionPopupView extends View {
    /**
     * @param {string} parentId 
     * @param {Totals} totals 
     */
    constructor(parentId) {
        super(parentId, PageIds.VERSION_POPUP);

        /**
         * @constant
         */
        this.versions = [
            {
                name: 'Update 15',
                date: '3 Oct 2025',
                bullets: [
                    'Fixed prestige timer reset on save load',
                    'Gold per block more expensive',
                    'Version / Release Notes view (this popup)'
                ]
            },
            {
                name: 'Update 14',
                date: '2 Oct 2025',
                bullets: [
                    'Gold upgrades are more expensive.',
                    'Figured out where the jittery motion when falling comes from.',
                    'Stopped saving grids during fast falling that will never be loaded again',
                    'Fixed issue where deepest layer was not appearing in the layer progress view.'
                ]
            },
            {
                name: 'Update 13',
                date: '1 Oct 2025',
                bullets: [
                    'Added a bunch of gold upgrades including gold per block.',
                    'Fixed max speed of auto purchase/claim skills',
                    'Offline earnings included in the statistics.',
                    'Slightly improved wireframe rendering mode'
                ]
            },
            {
                name: 'Update 12',
                date: '30 Sept 2025',
                bullets: [
                    'Simplified auto prestige'
                ]
            },
            {
                name: 'Update 11',
                date: '30 Sept 2025',
                bullets: [
                    'Prestige \'Layer Clear Countdown\' is 5 minutes instead of 10',
                    'Crew doesn\'t all start out on the same spot after prestige',
                    'Settings screen: enable/disable fps displayed on the screen',
                    'Settings screen: brain debug option moved to the settings screen',
                    'Settings screen: block health column rendered',
                    'Settings screen: skills/effects rendered',
                    'Settings screen: wireframe mode (render blocks as rectangles to lower GPU usage)',
                    'Settings screen: FPS throttle (15 fps, 30 fps, etc)'
                ]
            },
            {
                name: 'Update 10',
                date: '29 Sept 2025',
                bullets: [
                    'Tinkering with the laser to get it to fire more',
                    'Fixed null pointer bug reported by player',
                    'Doubled the value of the \'Mined Damage\' bonus'
                ]
            },
            {
                name: 'Update 9',
                date: '29 Sept 2025',
                bullets: [
                    'Fixed another looping/stuck miner bug.',
                    'Added block damage skill (too OP?)',
                    'Missiles speed increases when fall speed is accelerated.',
                    'Popup window background color is darker to make things easier to read'
                ]
            },
            {
                name: 'Update 8',
                date: '29 Sept 2025',
                bullets: [
                    'Hopefully fixed \'cycle bug\' where miner gets stuck in a loop.',
                    'Hopefully fixed \'pause and do nothing\' bug where miners just sit there and do nothing',
                    'Added ruby upgrades'
                ]
            },
            {
                name: 'Update 7',
                date: '28 Sept 2025',
                bullets: [
                    'Reworked crew search area logic',
                    'Fall speed skill'
                ]
            },
            {
                name: 'Update 6',
                date: '20 Sept 2025',
                bullets: [
                    'Fix: Blocks destroyed by missiles can drop loot'
                ]
            },
            {
                name: 'Update 5',
                date: '20 Sept 2025',
                bullets: [
                    'Improvements to laser targeting logic',
                    'Missiles fire towards targets.',
                    'Path finding optimization',
                    'Miners aren\'t slowed when plowing through wimpy blocks',
                    'Missiles fly a little faster',
                    'On-screen debug text.'
                ]
            },
            {
                name: 'Update 4',
                date: '16 Sept 2025',
                bullets: [
                    'Path optimization when blocks have very low health',
                    'Terrain save optimization',
                    'Crew focuses on going deeper when bloks are wimpy',
                    'Laser should be shooting at more stuff now.'
                ]
            },
            {
                name: 'Update 3',
                date: '15 Sept 2025',
                bullets: [
                    'Fixed skill duration bug',
                    'Fixed sprite for Defective Cobalt layer.',
                    'Orbit: range is larger, fixed UI bug in skill tree.',
                    'Laser: tinkering w/ laser targeting logic',
                    'Offline earnings adjusted',
                    'Offline prestige earnings changed.',
                    'Crew Brain Debug View',
                    'Performance View',
                    'Depth damage multiplier bug on game reset.',
                    'Crew brain changes'
                ]
            },
            {
                name: 'Update 2',
                date: '13 Sept 2025',
                bullets: [
                    'Fixed offline earnings crash bug',
                    'Re-implemented how offline earnings are calculated',
                    'Offline earnings enabled by default',
                    'Offline support added for: ore, ruby',
                    'Narrower prestige popup window'
                ]
            },
            {
                name: 'Update 1',
                date: '11 Sept 2025',
                bullets: [
                    'Reduced rate at which block health increases per depth.',
                    'Mining a tile reveals more tiles in the direction of mining.',
                    'Unlocking 1st extra miner costs 1 prestige point instead of 2.',
                    'Minor improvements to character decision making.',
                    'Increased prestige damage bonus from 10% to 20%/prestige.',
                    'Slightly increased mined ore earnings.'
                ]
            },
            {
                name: 'Initial Beta Release',
                date: '10 Sept 2025',
                bullets: [
                    'Yay'
                ]
            },
        
        ];
    }

    /**
     * Invoked at startup or after a save has been loaded.
     * @override
     */
    initializeView() {
        const parentElement = Page.getElement(this.parentId);
        const prestigePopup = Page.createElement('div', parentElement, this.getElementId(), 'popup-window-version');

        const container = Page.createElement('div', prestigePopup, null, null);

        ////////////////////////////////////////
        // Header
        ////////////////////////////////////////

        const header = Page.createElement('div', container, null, 'popup-window-header');
        header.innerHTML = 'Version';

        const thisRef = this;

        header.onclick = function () {
            thisRef.setViewVisible(false);
            return false;
        };

        ////////////////////////////////////////
        // Content
        ////////////////////////////////////////

        const contentBody = Page.createElement('div', container, null, 'version-body');

        for (let i = 0; i < this.versions.length; i++) {
            this.addSection(contentBody, this.versions[i]);
        }

        this.setInitialVisibility(false);

        super.initializeView();
    }

    /**
     * @private
     * @param {HTMLElement} parent 
     * @param {Object} versionInfo 
     */
    addSection(parent, versionInfo) {
        const section = Page.createElement('div', parent, null, 'version-section');

        const topRow = Page.createElement('div', section, null, 'version-section-top');

        // {
        //     name: 'Update 15',
        //     date: '3 Oct 2025',
        //     bullets: [
        //         'Fixed prestige timer reset on save load',
        //         'Gold per block more expensive',
        //         'Version / Release Notes view (this popup)'
        //     ]
        // },

        const nameElement = Page.createElement('div', topRow, null, null);
        nameElement.innerHTML = versionInfo.name;

        const dateElement = Page.createElement('div', topRow, null, 'version-date');
        dateElement.innerHTML = versionInfo.date;

        const bulletContainer = Page.createElement('div', section, null, null);

        const listElement = Page.createElement('ul', bulletContainer, null, null);

        for (let i = 0; i < versionInfo.bullets.length; i++) {
            const bulletElement = Page.createElement('li', listElement, null, null);
            bulletElement.innerHTML = versionInfo.bullets[i];
        }
    }

    // /**
    //  * @override
    //  */
    // updateViewContents() {
    //     const prestige = this.totals.unclaimedPrestige;

    //     if (!this.displayedPrestige.equals(prestige)) {
    //         this.displayedPrestige.copy(prestige);

    //         const earnedPrestigeText = this.getEarnedPrestigeText();

    //         this.prestigeEarnedInfo.innerHTML = earnedPrestigeText;
    //         this.prestigeEarnedInfo2.innerHTML = earnedPrestigeText;
    //     }
    // }

}